import { sagas as testSaga } from "./testSaga";
import { sagas as catalogoSaga } from "./catalogoSaga";
import { sagas as rubrosSaga } from "./rubrosSaga";
import { sagas as articuloSaga } from "./articuloSaga";
import { sagas as pedidoSaga } from "./pedidosSaga";
import { sagas as usuariosSaga } from "./usuariosSaga";
import { sagas as confirmarCorreoSaga } from "./ConfirmarCorreoSaga";
import { sagas as promocionesSaga } from "./promocionesSaga";
import { sagas as sessionSaga } from "./sessionSaga";
import { sagas as contenidoSaga } from "./contenidoSaga";
import { sagas as configuracionesSaga } from "./configuracionesSaga";
import { sagas as TurneroSaga } from "./TurneroSaga";
import { sagas as ofertaSaga } from "./ofertaSaga";
import { sagas as sucursalesSaga } from "./sucursalesSaga";
import { sagas as marcaSaga } from "./marcaSaga";
import { sagas as proveedorSaga } from "./proveedorSaga";
import { sagas as ConfigGlobalSaga } from "./ConfigGlobalSaga";
import { sagas as localidadEntregaSaga } from "./localidadEntregaSaga";
import { sagas as nivelSaga } from "./nivelSaga";

export default [
  ...testSaga,
  ...catalogoSaga,
  ...rubrosSaga,
  ...articuloSaga,
  ...pedidoSaga,
  ...usuariosSaga,
  ...confirmarCorreoSaga,
  ...promocionesSaga,
  ...sessionSaga,
  ...contenidoSaga,
  ...TurneroSaga,
  ...configuracionesSaga,
  ...ofertaSaga,
  ...sucursalesSaga,
  ...marcaSaga,
  ...proveedorSaga,
  ...ConfigGlobalSaga,
  ...localidadEntregaSaga,
  ...nivelSaga,
];
